import { render, staticRenderFns } from "./EmpleadosMarcaciones.vue?vue&type=template&id=70f5f13e&"
import script from "./EmpleadosMarcaciones.vue?vue&type=script&lang=js&"
export * from "./EmpleadosMarcaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports